import type { TradeInOrders } from './resources'
import type { Grade, Status, StatusOriginal } from './resources/getTradeInOrders'

export type FormFields = {
  orders: TradeInOrders[]
}

export const normalizeOrders = (
  mapVisibleList: TradeInOrders[],
  queryStatus: 'PRICE_REQUEST' | 'SENT'
) =>
  mapVisibleList.map(el => ({
    ...el,
    grade: queryStatus === 'PRICE_REQUEST' ? el.grade || 'B' : el.grade,
    finalGrade: queryStatus === 'SENT' ? el.finalGrade || 'B' : el.finalGrade,
  }))

const setNewStatusCode = (orderStatus: Status | StatusOriginal) => {
  if (orderStatus === 'PRICE_REQUEST') return 'PRICE_ESTIMATION'
  if (orderStatus === 'SENT') return 'FINAL_PRICING'
  return 'REJECTED'
}

const setGrade = (
  orderStatus: Status | StatusOriginal,
  grade: Grade | null,
  finalGrade: Grade | null
): Grade => {
  if (orderStatus === 'PRICE_REQUEST' && grade) return grade
  if (orderStatus === 'SENT' && finalGrade) return finalGrade
  return 'B'
}

const setPrice = (
  orderStatus: Status | StatusOriginal,
  estimatedPrice: number | null,
  finalPrice: number | null
): number => {
  if (orderStatus === 'PRICE_REQUEST' && estimatedPrice) return estimatedPrice
  if (orderStatus === 'SENT' && finalPrice) return finalPrice
  return 0
}

export const filterUpdatedData = (
  values: FormFields,
  queryStatus: string | null,
  normalizedOrders: TradeInOrders[]
) =>
  values.orders.filter((order, idx) => {
    const initial = normalizedOrders[idx]

    if (queryStatus === 'PRICE_REQUEST') {
      return Number(order.estimatedPrice) !== initial.estimatedPrice && order.grade !== null
    }
    if (queryStatus === 'SENT') {
      return Number(order.finalPrice) !== initial.finalPrice && order.finalGrade !== null
    }
    return []
  })

export const mapUpdatedOrders = (updatedOrders: TradeInOrders[], currency?: string) =>
  updatedOrders.map(order => {
    const { orderId, estimatedPrice, grade, finalPrice, finalGrade, orderStatus } = order
    return {
      orderId,
      grade: setGrade(orderStatus, grade, finalGrade),
      price: setPrice(orderStatus, Number(estimatedPrice), Number(finalPrice)),
      currencyCode: currency ?? '',
      newStatusCode: setNewStatusCode(orderStatus),
      comment: '',
    }
  })
